import { FC, useCallback, useEffect } from 'react';

import {
  useContractListStore,
  useContractRegistrationStore,
  useContractEditStore,
} from 'page/CustomerPage/hooks';
import { Contract } from 'types/contract';
import { ContractListView } from 'page/CustomerPage/components/ContractListView';

export const ContractList: FC = () => {
  const {
    loading,
    contracts,
    finalUpdateTime,
    selectedContract,
    selectContract,
    fetchContracts,
  } = useContractListStore();
  const { openModal: openRegistrationModal } = useContractRegistrationStore();
  const {
    openModal: openEditModal,
    setForm,
    changeStartDate,
    changeEndDate,
  } = useContractEditStore();

  useEffect(() => {
    void fetchContracts();
  }, [fetchContracts, finalUpdateTime]);

  /**
   * 契約一覧で行をクリックしたときの処理
   * @param contract クリックされた契約
   */
  const handleContractClick = useCallback(
    (contract: Contract) => {
      selectContract(contract);
    },
    [selectContract],
  );

  /**
   * 契約が選択されたときの処理
   */
  useEffect(() => {
    if (!selectedContract) {
      return;
    }
    setForm({
      menuId: selectedContract.menuId.toString(),
      valid: selectedContract.valid,
    });
    changeStartDate(selectedContract.startDate);
    changeEndDate(selectedContract.endDate);
    openEditModal();
  }, [
    changeEndDate,
    changeStartDate,
    openEditModal,
    selectedContract,
    setForm,
  ]);

  return (
    <ContractListView
      loading={loading}
      contracts={contracts}
      handleContractClick={handleContractClick}
      handleNewContractClick={() => openRegistrationModal()}
    />
  );
};
